export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/theme/components/scorecard/MetricsLabels/index.js